<script module lang="ts">
  import type { Snippet } from 'svelte';
  import type { NavPoints } from './navigation.types';
  import type { NavigationVariant } from '../../services/NavigationService.svelte';

  export const allowedTags = ['ul', 'div'] as const;
  export type AllowedTag = (typeof allowedTags)[number];

  export interface Props {
    tag?: AllowedTag;
    variant?: NavigationVariant;
    points?: NavPoints;
    children?: Snippet;
  }
</script>

<script lang="ts">
  import { untrack } from 'svelte';
  import NavPointsList from './NavPointsList.svelte';
  import { LayerService } from '../../services/LayerService.svelte';
  import { NavigationService } from '../../services/NavigationService.svelte';

  const { tag, variant, points, children }: Props = $props();

  // -
  const DefaultTag = allowedTags[0];
  const ElementTag = $derived(tag && allowedTags.includes(tag) ? tag : DefaultTag);

  // -
  const Layer = new LayerService();
  const MyLayer = Layer.upNavigationLayer();

  // -
  const NavigationVariants = new NavigationService();
  const MyVariant = NavigationVariants.resolveVariant(untrack(() => variant));
</script>

<svelte:element this={ElementTag} class="nav layer{MyLayer} {MyVariant === 'bar' ? 'navBar' : 'navTree'}">
  {#if points}
    <NavPointsList {points} />
  {/if}
  {@render children?.()}
</svelte:element>

<style lang="scss">
  @use '../../../styles/display';

  .nav {
    @include display.block;
    line-height: 1;
    white-space: nowrap;
    cursor: default;
    font-size: var(--nav-font-size, 1em);
    margin-left: var(--nav-margin-left, 0);

    &.navBar.layer1 {
      display: flex;
      flex-wrap: wrap;
      gap: 0.25rem 0.5rem;

      > :global(.navPoint) {
        margin-top: 0;
      }
    }
  }
</style>
